/** local@domain.tld — e.g. 123@gmail.com */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function getEmailValidationError(value: string | undefined): string | undefined {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return undefined;
  if (!EMAIL_PATTERN.test(trimmed)) return "Invalid email address";
  return undefined;
}

export function getPhoneValidationError(value: string | undefined): string | undefined {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return undefined;
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length < 7) return "Invalid phone number";
  return undefined;
}

export function isContactDraftValid(draft: { email?: string; phone?: string } | undefined): boolean {
  if (!draft) return true;
  return !getEmailValidationError(draft.email) && !getPhoneValidationError(draft.phone);
}
